import { useEffect } from 'react';

import Navbar from '@/components/layout/Navbar';
import HeroSection from '@/components/sections/HeroSection';



import VehicleShowcase from '@/components/sections/VehicleShowcase';
import PackagesSection from '@/components/sections/PackagesSection';
import ServicesSection from '@/components/sections/ServicesSection';
import WhyChooseUsSection from '@/components/sections/WhyChooseUsSection';
import ReviewsSection from '@/components/sections/ReviewsSection';
import ContactSection from '@/components/sections/ContactSection';
import Footer from '@/components/layout/Footer';
import WhatsAppFloat from '@/components/common/WhatsAppFloat';

const Index = () => {
  useEffect(() => {
    // Register Service Worker for PWA
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/service-worker.js')
          .then((registration) => {
            console.log('SW registered:', registration);
          })
          .catch((error) => {
            console.log('SW registration failed:', error);
          });
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main>
        {/* Hero Section with integrated Booking Form */}
        <HeroSection />

        {/* Vehicle Showcase */}
        <VehicleShowcase />

        {/* Services */}
        <ServicesSection />

        {/* Why Choose Us */}
        <WhyChooseUsSection />

        {/* Travel Packages */}
        <PackagesSection />

        {/* Customer Reviews */}
        <ReviewsSection />

        {/* Contact Section */}
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating WhatsApp Button */}
      <WhatsAppFloat />
      {/* End of Layout */}
    </div>
  );
};

export default Index;
